import React, { useEffect } from "react"
import Footer from "./Footer"
import Header from "./Header"

const Layout = ({ children, location }) => {
  useEffect(() => {
    const smoothScrollLinks = document.querySelectorAll('a[href^="#"]')
    // Select all anchor links with a href value that starts with #

    smoothScrollLinks.forEach(link => {
      link.addEventListener("click", function (e) {
        e.preventDefault() // Prevent the default link behavior

        const target = document.querySelector(this.getAttribute("href"))
        // Get the target element based on the href attribute of the link

        if (target) {
          // If the target element exists, scroll to it smoothly
          const body = document.body
          const html = document.documentElement
          const offset = target.offsetTop

          body.style.scrollBehavior = "smooth"
          html.style.scrollBehavior = "smooth"
          window.scrollTo({
            top: offset,
            behavior: "smooth",
          })

          // Reset the scroll behavior to the default after scrolling is complete
          setTimeout(function () {
            body.style.scrollBehavior = "initial"
            html.style.scrollBehavior = "initial"
          }, 1000) // Change the value to match the duration of your smooth scroll animation
        }
      })
    })
  }, [])

  useEffect(() => {
    document.querySelector("body").classList.remove("menu-open")
  }, [])

  return (
    <>
      <Header location={location} />
      {children}
      <Footer />
      <div className="hidden pt-0 pt-30 pt-50 pt-110 lgscreen:pt-30 pb-110 pb-120 lgscreen:pb-30 baptiste-site sonnyandirene-site surfshack-site lilys-site labelle-site paranga-site thebungalow-site bilboa-site bobos-site zenzero-site thenines-site blanko-site chinchilla-site incognito-site marly-site"></div>
    </>
  )
}

export default Layout
